import { useMemo as s, isValidElement as i } from "react";
import { ThemeUILockBreakpointProvider as l } from "@theme-ui/css";
import { cloneElementWithCss as c } from "./utils.js";
import { jsx as u, Fragment as a } from "theme-ui/jsx-runtime";
const b = {
  mobile: 0,
  tablet: 1,
  desktop: 2
}, x = ({
  showOn: t,
  display: e = "block",
  lockBreakpoint: o,
  children: n
}) => {
  const r = s(() => {
    switch (t) {
      case "mobiles":
        return [e, null, "none"];
      case "mobile":
        return [e, "none"];
      case "tablet":
        return ["none", e, "none"];
      case "tablet-desktop":
        return ["none", e];
      case "desktop":
        return ["none", null, e];
      default:
        return t ? e : "none";
    }
  }, [t, e]), m = s(() => t !== void 0 && i(n) ? c(n, {
    sx: {
      display: r
    }
  }) : n, [n, t, r]);
  return o === void 0 ? /* @__PURE__ */ u(a, {
    children: m
  }) : /* @__PURE__ */ u(l, {
    breakpointIndex: b[o],
    children: m
  });
};
export {
  x as Responsive
};
